import { render, staticRenderFns } from "./formAssessmentQuestion.vue?vue&type=template&id=c2847324"
import script from "./formAssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./formAssessmentQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports